import ReactDOM from 'react-dom/client';
import './index.css';
// Antes de renderizar: el navegador dispara beforeinstallprompt muy pronto y
// hay que estar escuchando para no perderlo.
import './pwa/installPrompt';
import App from './App';
import { registerServiceWorker } from './pwa/registerServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

registerServiceWorker();
